class FormRuleAction {
    Id: number;
    FormRuleId: number;
    DataName: string;
    IsRequired: boolean;
    IsHidden: boolean;
    IsReadonly: boolean;
    Sequence: number;
    FormRuleName: string;

    constructor(id: number, formRuleId: number, dataName: string, isRequired: boolean, isHidden: boolean, isReadonly: boolean, sequence: number, formRuleName: string) {
        this.Id = id;
        this.FormRuleId = formRuleId;
        this.DataName = dataName;
        this.IsRequired = isRequired;
        this.IsHidden = isHidden;
        this.IsReadonly = isReadonly;
        this.Sequence = sequence;
        this.FormRuleName = formRuleName;
    }
}

export default FormRuleAction;